/**
 * @description 将数据字典数据映射为{label: 'xx', value: 'xx'}形式
 * @param {Object} dictData 字典数据
 * @returns {Array} [{ label: 'xx', value: 'xx' }, { label: 'xx', value: 'xx' }]
 */
export const formatDictDataToLabelValue = dictData => {
    return Object.entries(dictData).map(v => ({ label: v[1], value: v[0] }));
};
